














































































































import { Vue, Component } from 'vue-property-decorator'
import {
  getGroupMapList,
  getFirstRouterMap,
  getSecondRouterMap,
  getGroupRouterList
} from '@/api/permission/index'
import {
  addGroup,
  updateGroup,
  deleteGroup,
  addGroupRouter,
  deleteGroupRouter
} from '@/api/permission/permission-role/role'
import { findIndexOfObj } from '@/utils/tool'
import { generatePermissionTree } from '@/utils/routerTree'

interface IGroup {
  id: number | string
  name: string
  isEdit: boolean
}

interface IPermission {
  id: number | string
  name: string
  isUse: boolean,
  children: IPermission[]
}

@Component({
  name: 'PermissionRole'
})
export default class extends Vue {
  NODE_KEY = 'id'
  value = true
  checked = true
  activeIndex: any = ''
  isAdd = false
  addName = ''
  groupList: IGroup[] = []
  tempName = ''
  routerList: any = {}
  firstRouter: any = {}
  secondRouter: any = {}
  groupId: number | string = ''
  treeList: any[] = []
  tableLoading = false

  created() {
    this.getGroupMapList()
    this.getFirstRouterMap()
    this.getSecondRouterMap()
  }

  // 获取角色列表
  async getGroupMapList() {
    let res: any = await getGroupMapList()
    let list = (Object.entries(res.data) as any[]) as string[][]
    this.groupList = list.map(item => {
      return { id: item[0], name: item[1], isEdit: false }
    })
  }

  async getFirstRouterMap() {
    let res: any = await getFirstRouterMap()
    this.firstRouter = res.data
  }

  async getSecondRouterMap() {
    let res: any = await getSecondRouterMap()
    this.secondRouter = res.data
  }

  async getRouterList() {
    let res: any = await getGroupRouterList({ groupId: this.groupId })
    this.routerList = res.data
  }

  async addGroupRouter(ids: string) {
    let res:any = await addGroupRouter({
      id: this.groupId,
      routerId: ids
    })
    if (res.status.code === 0) {
      this['$message'].success('添加成功')
      this.getGroupMapList()
    } else {
      this['$message'].error('添加失败')
    }
  }

  generatePermissionTree(
    routerList: any[],
    fisrtRouter: any,
    secondRouter: any
  ) {
    this.treeList = generatePermissionTree(
      routerList,
      fisrtRouter,
      secondRouter
    )
    console.log(this.treeList)
  }

  async initPermissionTree() {
    await this.getRouterList()
    this.generatePermissionTree(
      this.routerList,
      this.firstRouter,
      this.secondRouter
    )
  }

  // 点击获取 对应角色权限路由表
  handleClickRole(index: any, item: IGroup) {
    this.tableLoading = true
    setTimeout(() => {
      this.tableLoading = false
    }, 1000)
    this.activeIndex = index
    this.groupId = item.id
    this.initPermissionTree()
  }

  // 添加, 取消权限路由
  async handleOperateLevel1(item: IPermission) {
    // 获取一级路由下的所有三级路由id
    const { isUse, children } = item
    if (!children.length) {
      this['$message'].warning('没有有效权限添加或取消!')
      return
    }
    console.log(item)
    let thirdIds:IPermission[] = (children as any[])
      .reduce((prev, cur) => {
        return prev.concat(cur.children)
      }, [])
    let res:any = {}
    let params = {
      id: this.groupId,
      routerId: thirdIds.map(item => item.id).join()
    }
    res = isUse ? await addGroupRouter(params) : await deleteGroupRouter(params)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
      // 变更状态
      children.forEach(item => {
        item.isUse = isUse
        item.children.forEach(item1 => {
          item1.isUse = isUse
        })
      })
    } else {
      this['$message'].error('提交失败')
      // eslint-disable-next-line require-atomic-updates
      item.isUse = !isUse
    }
  }

  async handleOperateLevel2(item: IPermission) {
    // 获取二级路由下的所有三级路由id
    const { isUse, children } = item
    if (!children.length) {
      this['$message'].warning('没有有效权限添加或取消!')
      return
    }
    console.log(item)
    let thirdIds = children.map(item => item.id)
    let res:any = {}
    let params = {
      id: this.groupId,
      routerId: thirdIds.join()
    }
    res = isUse ? await addGroupRouter(params) : await deleteGroupRouter(params)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
      // 变更状态
      children.forEach(item => {
        item.isUse = isUse
      })
    } else {
      this['$message'].error('提交失败')
      // eslint-disable-next-line require-atomic-updates
      item.isUse = !isUse
    }
  }

  async handleOperateLevel3(item: IPermission) {
    // 点击后状态
    const { isUse, id } = item
    let res:any = {}
    let params = {
      id: this.groupId,
      routerId: id.toString()
    }
    res = isUse ? await addGroupRouter(params) : await deleteGroupRouter(params)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
    } else {
      this['$message'].error('提交失败')
      // eslint-disable-next-line require-atomic-updates
      item.isUse = !isUse
    }
  }

  // 修改角色
  handleEdit(index: number, item: IGroup) {
    this.tempName = item.name
    // 设置编辑状态
    if (!item.isEdit) {
      this.$set(item, 'isEdit', true)
    }
    // 输入框聚焦
    this.$nextTick(() => {
      let ref = (this.$refs[`RefInput${index}`] as any[])[0]
      ref && ref.$refs.input.focus()
    })
  }
  async handleEditInput(item: IGroup) {
    // 修改后的name
    const { name, id } = item
    // 判空
    if (!name) {
      this['$message'].warning('请输入有效名称!')
      item.name = this.tempName
      item.isEdit = false
      return
    }
    // 判重
    if (name === this.tempName) {
      item.isEdit = false
      return false
    }
    // API
    let res: any = await updateGroup({ id, name })
    if (res.status.code === 0) {
      this['$message'].success('修改成功!')
    } else {
      this['$message'].error('修改失败!')
    }
    this.$set(item, 'isEdit', false)
  }

  // 删除角色
  handleDelete(item: IGroup) {
    this.$confirm('确认删除该角色?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        const { id } = item
        let res: any = await deleteGroup({ id })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          let objIndex = findIndexOfObj(item, this.groupList)
          setTimeout(() => {
            this.groupList.splice(objIndex, 1)
          }, 1500)
        } else {
          this['$message'].error('删除失败,请稍后重试或联系相关管理员')
        }
      })
      .catch(() => {})
  }

  // 新增角色
  handleAdd() {
    this.isAdd = true
    this.$nextTick(() => {
      if (this.$refs['AddInput']) {
        (this.$refs['AddInput'] as any).$refs.input.focus()
      }
    })
  }
  async handleAddInput() {
    // 判空
    if (!this.addName) {
      this.isAdd = false
      this['$message'].warning('请输入有效角色名!')
      return
    } else {
      // 判重
      let nameList = this.groupList.map(item => item.name)
      if (nameList.includes(this.addName)) {
        this['$message'].warning('角色名重复,请重新输入!')
        this.isAdd = false
        this.addName = ''
        return
      }
      // API
      let res: any = await addGroup({ name: this.addName })
      console.log(res)
      const { id } = res.data
      if (res.status.code === 0) {
        this['$message'].success('提交成功')
        this.isAdd = false
        this.addName = ''
        setTimeout(() => {
          this.groupList.push({
            id: id,
            name: this.addName,
            isEdit: false
          })
        }, 1500)
      } else {
        this['$message'].error('提交失败')
      }
    }
    // 退出编辑
    this.isAdd = false
  }
}
